import Vue from 'vue';
import Component from 'vue-class-component';

import BbModal from 'common/components/BbModal';
import BbForm from 'components/BbForm';
import BbField from 'components/BbField';

@Component({
  components: {
    BbModal,
    BbForm,
    BbField,
  },
  props: ['item'],
})
export default class GiftMessageModalComponent extends Vue {}
